export enum FlowIndex {
  initial = 0,
  thankyou = 2,
}
